import { defineStore } from 'pinia'
import { useStorage } from '@vueuse/core'

export const useNotificationsStore = defineStore('notifications', {
  state: () => ({
    assetAlertNotified: useStorage('assetAlertNotified', false, localStorage),
  }),
  getters: {
    isAssetAlertNotified(state) {
      return state.assetAlertNotified
    },
  },
  actions: {
    SET_ASSET_ALERT(value: boolean) {
      this.assetAlertNotified = value
    },
    hideAlertNotification() {
      this.SET_ASSET_ALERT(true)
    },
    showAlertNotification() {
      this.SET_ASSET_ALERT(false)
    },
    reset() {
      this.SET_ASSET_ALERT(false)
    },
  },
})
